var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticStyle:{"margin":"10px 10px 10px 10px"}},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t("Authorization.AccessDenied"))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }